export enum BreakPoints {
  Medium = '768px',
  Large = '992px',
}
